import * as React from 'react';

export interface PaginationProps {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Sets a number of available pages to show in the component */
  totalPages?: number;
  /** Specifies a currently selected page
   * @default 1
   */
  currentPage?: number;
  /** Defines a callback function which returns a selected page or an arrow ({`event`,`page`}) */
  onChange?(event: { event: React.SyntheticEvent; page: number }): void;
  /** Get pageNumber and returns url */
  pageUrl?(pageNumber: number): string;
  /** Sets next page label */
  nextLabel?: string;
  /** Sets previous page label */
  previousLabel?: string;
}
